// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1066":"ffd0c1f61d826a13","5546":"03eef5a3cd6ca01b"}[chunkId] + ".css";
};